/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claims_Form_IntroInputs */

const en_claims_form_intro = /** @type {(inputs: Claims_Form_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In order to submit a claim, please verify your account and enter in your policy information:`)
};

const fr_claims_form_intro = /** @type {(inputs: Claims_Form_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour soumettre une réclamation, veuillez vérifier votre compte et entrer vos informations de police :`)
};

/**
* | output |
* | --- |
* | "In order to submit a claim, please verify your account and enter in your policy information:" |
*
* @param {Claims_Form_IntroInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const claims_form_intro = /** @type {((inputs?: Claims_Form_IntroInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claims_Form_IntroInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claims_form_intro(inputs)
	return fr_claims_form_intro(inputs)
});